<template>
  <login-component-vue />
</template>

<script>
import LoginComponentVue from "./components/LoginComponent.vue";
export default {
  name: "Login",
  components: {
    LoginComponentVue,
  },
  data: () => ({}),
};
</script>

<style>
</style>